import {Model} from 'backbone';

export default class CostOption extends Model.extend({
  idAttribute: 'optionId'
}) {}